import { render, staticRenderFns } from "./DurationPicker.vue?vue&type=template&id=238dcad0&"
import script from "./DurationPicker.vue?vue&type=script&lang=js&"
export * from "./DurationPicker.vue?vue&type=script&lang=js&"
import style0 from "./DurationPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports